<template>
  <div class="email-step-editor-header-actions">
    <snappy-dropdown
      text="Actions"
      :items="actions"
      :button-font-size="16"
      @do-action="onDoAction"
      light
    ></snappy-dropdown>
    <shared-step-editor-header-button @clicked="onSave">
      {{ saving ? 'Saving...' : 'Save' }}
    </shared-step-editor-header-button>
  </div>
</template>

<script>
import SnappyDropdown from '../../../SnappyDropdown';
import SharedStepEditorHeaderButton from '../shared/SharedStepEditorHeaderButton.vue';

export default {
  name: 'EmailStepEditorHeaderActions',
  components: {
    SnappyDropdown,
    SharedStepEditorHeaderButton,
  },
  props: {
    unlayerReady: Boolean,
    saving: Boolean,
  },
  computed: {
    actions() {
      return [
        {text: 'Edit Details', actionName: 'edit-email', disabled: !this.unlayerReady},
        {text: 'Send Test', actionName: 'send-email', disabled: !this.unlayerReady},
        {text: 'Preview', actionName: 'preview', disabled: !this.unlayerReady},
      ];
    },
  },
  methods: {
    onDoAction(action) {
      this.$emit(action);
    },
    onSave() {
      this.$emit('save-email');
    },
  },
};
</script>

<style scoped lang="scss">
.email-step-editor-header-actions {
  display: flex;
  gap: 10px;
}
</style>
